import gql from 'graphql-tag';

import {
  RosterIdentityBaseDetails,
  RosterIdentityLinkedIdentityDetails,
  RosterIdentityLinkedIdentityContactMethodDetails,
  RosterIdentityLinkedIdentityAddressFields,
  RosterQrCodeDetails,
  RosterQrCodeExportDetails,
} from '../fragments/roster-identity';

export const rosterIdentityCreate = gql`
  mutation rosterIdentityCreate($input: RosterIdentityCreateInput!) {
    rosterIdentityCreate(input: $input) {
      roster_identity {
        id
        ...RosterIdentityBaseDetails
      }
    }
  }
  ${RosterIdentityBaseDetails}
`;

export const rosterIdentityUpdate = gql`
  mutation rosterIdentityUpdate($input: RosterIdentityUpdateInput!) {
    rosterIdentityUpdate(input: $input) {
      roster_identity {
        id
        ...RosterIdentityBaseDetails
      }
    }
  }
  ${RosterIdentityBaseDetails}
`;

export const selectedIdentityUpdate = gql`
  mutation selectedIdentityUpdate($input: SelectedIdentityUpdateInput!) {
    selectedIdentityUpdate(input: $input) {
      selected_identity {
        id
        claimed
      }
    }
  }
`;

export const rosterIdentitiesCreate = gql`
  mutation rosterIdentitiesCreate($input: RosterIdentitiesCreateInput!) {
    rosterIdentitiesCreate(input: $input) {
      success
      roster_identities {
        id
        ...RosterIdentityBaseDetails
      }
      invalid_names
      invalid_phone_numbers
      invalid_addresses
      invalid_ref_ids
    }
  }
  ${RosterIdentityBaseDetails}
`;

export const rosterIdentitiesDelete = gql`
  mutation rosterIdentitiesDelete($input: RosterIdentitiesDeleteInput!) {
    rosterIdentitiesDelete(input: $input) {
      success
    }
  }
`;

export const rosterIdentityListCreate = gql`
  mutation rosterIdentityListCreate($input: RosterIdentityListCreateInput!) {
    rosterIdentityListCreate(input: $input) {
      roster_identity_list {
        id
        name
      }
    }
  }
`;

export const rosterIdentityLinkedIdentityCreate = gql`
  mutation rosterIdentityLinkedIdentityCreate(
    $input: RosterIdentityLinkedIdentityCreateInput!
  ) {
    rosterIdentityLinkedIdentityCreate(input: $input) {
      roster_identity_linked_identity {
        id
        ...RosterIdentityLinkedIdentityDetails
      }
    }
  }
  ${RosterIdentityLinkedIdentityDetails}
`;

// Phone only, by design: a marketing Account never holds a phone number, and
// email addresses belong to the RosterIdentity, so they are written through
// rosterIdentityUpdate instead.
export const rosterIdentityLinkedIdentityUpdate = gql`
  mutation rosterIdentityLinkedIdentityUpdate(
    $input: RosterIdentityLinkedIdentityUpdateInput!
  ) {
    rosterIdentityLinkedIdentityUpdate(input: $input) {
      roster_identity_linked_identity {
        id
        ...RosterIdentityLinkedIdentityContactMethodDetails
      }
    }
  }
  ${RosterIdentityLinkedIdentityContactMethodDetails}
`;

export const rosterIdentityLinkedIdentityAddressCreate = gql`
  mutation rosterIdentityLinkedIdentityAddressCreate(
    $input: RosterIdentityLinkedIdentityAddressCreateInput!
  ) {
    rosterIdentityLinkedIdentityAddressCreate(input: $input) {
      roster_identity_linked_identity_address {
        id
        ...RosterIdentityLinkedIdentityAddressFields
      }
    }
  }
  ${RosterIdentityLinkedIdentityAddressFields}
`;

export const rosterIdentityLinkedIdentityAddressUpdate = gql`
  mutation rosterIdentityLinkedIdentityAddressUpdate(
    $input: RosterIdentityLinkedIdentityAddressUpdateInput!
  ) {
    rosterIdentityLinkedIdentityAddressUpdate(input: $input) {
      roster_identity_linked_identity_address {
        id
        ...RosterIdentityLinkedIdentityAddressFields
      }
    }
  }
  ${RosterIdentityLinkedIdentityAddressFields}
`;

export const rosterIdentityCreateFromIdentity = gql`
  mutation rosterIdentityCreateFromIdentity(
    $input: RosterIdentityCreateFromIdentityInput!
  ) {
    rosterIdentityCreateFromIdentity(input: $input) {
      roster_identity {
        id
        ...RosterIdentityBaseDetails
      }
    }
  }
  ${RosterIdentityBaseDetails}
`;

export const rosterQrCodeBlanksCreate = gql`
  mutation rosterQrCodeBlanksCreate($input: RosterQrCodeBlanksCreateInput!) {
    rosterQrCodeBlanksCreate(input: $input) {
      success
      roster_qr_codes {
        ...RosterQrCodeDetails
      }
    }
  }
  ${RosterQrCodeDetails}
`;

export const rosterQrCodesCreate = gql`
  mutation rosterQrCodesCreate($input: RosterQrCodesCreateInput!) {
    rosterQrCodesCreate(input: $input) {
      success
    }
  }
`;

export const rosterQrCodeDelete = gql`
  mutation rosterQrCodeDelete($input: RosterQrCodeDeleteInput!) {
    rosterQrCodeDelete(input: $input) {
      success
    }
  }
`;

export const rosterQrCodeUpdate = gql`
  mutation rosterQrCodeUpdate($input: RosterQrCodeUpdateInput!) {
    rosterQrCodeUpdate(input: $input) {
      roster_qr_code {
        ...RosterQrCodeDetails
      }
    }
  }
  ${RosterQrCodeDetails}
`;

export const rosterQrCodeExportCreate = gql`
  mutation rosterQrCodeExportCreate($input: RosterQrCodeExportCreateInput!) {
    rosterQrCodeExportCreate(input: $input) {
      roster_qr_code_export {
        ...RosterQrCodeExportDetails
      }
    }
  }
  ${RosterQrCodeExportDetails}
`;
